import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderTop: `solid 1px ${theme.colorPalette.beige_50}`,
    padding: theme.spacing(4, 8),
    position: 'relative',
    ...reskinStyles(theme, { '&:first-child': { borderTop: 'none' } })
  },
  completed: {
    backgroundColor: theme.colorPalette.beige_25
  },
  task: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  },
  taskInfo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(2),
    flex: 1
  },
  taskName: {
    whiteSpace: 'nowrap',
    color: theme.colorPalette.green_80,
    lineHeight: 1.5
  },
  completedAt: {
    fontSize: 10,
    color: theme.colorPalette.green_80
  },
  tags: {
    marginTop: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap'
  },
  completedIcon: {
    height: 24,
    margin: 'auto 0',
    '--completed-icon-stroke': theme.colorPalette.green_legacy_86c440
  },
  pendingIcon: {
    height: '24px',
    width: '24px',
    margin: 'auto 0'
  },
  progress: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0
  },
  taskNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  learnMoreLink: {
    width: 'auto',
    height: 'auto',
    borderRadius: theme.spacing(2),
    color: theme.colors.action_text,
    padding: 0,
    marginLeft: theme.spacing(0.2),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  learnMoreLinkText: {
    ...reskinStyles(theme, theme.actionStyles.link),
    fontSize: 10,
    fontWeight: 400,
    color: theme.colors.action_text
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  actionButtonIcon: {
    marginRight: theme.spacing(1)
  },
  tag: {
    fontWeight: 400,
    color: theme.colorPalette.green_90,
    backgroundColor: theme.colorPalette.beige_50,
    '& > img': {
      height: 14,
      margin: theme.spacing(0, 1)
    },
    ...reskinStyles(theme, { ...theme.labelStyles.outlined, '& > img': { height: 14, margin: 0 } })
  },
  statusTag: {
    backgroundColor: 'white',
    ...reskinStyles(theme, { backgroundColor: 'transparent' })
  },
  questionIcon: {
    height: 12,
    padding: theme.spacing(0, 0.5)
  }
});

export default makeStyles(styles);
